export const BREAKPOINT_DESKTOP = 1199;
export const BREAKPOINT_LAPTOP = 992;
export const BREAKPOINT_TABLET = 768;
export const BREAKPOINT_MOBILE = 575;
